import { render } from "./CreatePanoramaFeatureModal.vue?vue&type=template&id=32df25f9"
import script from "./CreatePanoramaFeatureModal.vue?vue&type=script&lang=js"
export * from "./CreatePanoramaFeatureModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "32df25f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32df25f9', script)) {
    api.reload('32df25f9', script)
  }
  
  module.hot.accept("./CreatePanoramaFeatureModal.vue?vue&type=template&id=32df25f9", () => {
    api.rerender('32df25f9', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/Panorama/CreatePanoramaFeatureModal.vue"

export default script